import { ActiveSeriesScreenSkeleton } from './active-series-screen-skeleton'
import { SuggestedSeriesDismissDialog } from 'src/component/lets-get-moving/suggested-series-dismiss-dialog'
import React, { useState } from 'react'
import { PageContainer } from 'src/component/page-container/page-container'
import { BackArrow } from 'src/component/programmes/programme-back-arrow'
import { Grid } from 'src/component/ui/grid/grid'
import { PageTitle } from 'src/component/ui/page-title'
import { SeriesCardActive } from 'src/component/ui/series-card'
import { Programme } from 'src/dao/core-dao'
import { useCancelActiveProgramme } from 'src/hook/use-cancel-active-programme'
import { useMyStartedProgrammes } from 'src/hook/use-programmes'
import { toasterUtil } from 'src/util/toaster-util'

export const ActiveSeriesScreen = (): React.ReactElement => {
  const [programmePendingCancel, setProgrammePendingCancel] = useState<Programme | null>(null)
  const cancelMutation = useCancelActiveProgramme()
  const {
    data: hustlerSeries = [],
    isLoading,
    isError,
  } = useMyStartedProgrammes({
    onError: () => {
      toasterUtil.error('We are having difficulties loading your active series, please try again.')
    },
  })

  const activeSeries = hustlerSeries?.map((hp) => hp.programme) || []

  return (
    <PageContainer>
      <div className="py-6 md:py-[82px]">
        <div className="mb-10">
          <BackArrow />
        </div>
        <div className="mb-10">
          <PageTitle>Active Series</PageTitle>
        </div>
        {isLoading || isError ? (
          <ActiveSeriesScreenSkeleton />
        ) : (
          <>
            <Grid
              items={activeSeries}
              keyExtractor={(p) => p.id}
              renderItem={(programme) => (
                <SeriesCardActive series={programme} onCancelSeriesClick={() => setProgrammePendingCancel(programme)} />
              )}
            />
            <SuggestedSeriesDismissDialog
              isOpen={programmePendingCancel !== null}
              onClose={() => setProgrammePendingCancel(null)}
              onDismiss={() => {
                if (!programmePendingCancel) {
                  return
                }
                const programme = programmePendingCancel
                cancelMutation.mutate(
                  { programmeId: programme.id, programme },
                  { onSettled: () => setProgrammePendingCancel(null) },
                )
              }}
              isSubmitting={cancelMutation.isLoading}
            />
          </>
        )}
      </div>
    </PageContainer>
  )
}
